import React from 'react';
import {Redirect, Route, RouteProps} from 'react-router';
import { connect, ConnectedProps } from 'react-redux';
import {RootState} from 'app/rootReducer';
import {User} from 'oidc-client';
import {ApplicationAuthPaths, QueryParameterNames} from './authContstants';

type Props = ConnectedProps<typeof connector>;

class AuthorizeRoute extends React.Component<Props> {
    render() {
        const { isUserAuthenticated, isLoadingUser, ...rest } = this.props;
        if (isUserAuthenticated) {
            return <Route {...rest} />;
        }
        if (!isLoadingUser) {
            let link = document.createElement('a');
            link.href = this.props.location?.pathname || '';
            const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
            const redirectUrl = `${ApplicationAuthPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`;
            return <Redirect to={redirectUrl} />
        }
        return <div>Loading...</div>;
    }
}

const mapStateToProps = (state: RootState, ownProps: RouteProps) => {
    const user = state.oidc.user as User;
    return {
        isUserAuthenticated: user && !user.expired,
        isLoadingUser: state.oidc.isLoadingUser,
        ...ownProps
    };
};

const connector = connect(mapStateToProps);

export default connector(AuthorizeRoute);
